const indexItems = [
  { label: '2026最新电影', icon: 'ri-film-line', color: 'text-primary-400' },
  { label: '热播电视剧', icon: 'ri-tv-2-line', color: 'text-accent-400' },
  { label: '热门综艺', icon: 'ri-live-line', color: 'text-secondary-400' },
  { label: '动漫番剧', icon: 'ri-emotion-laugh-line', color: 'text-primary-400' },
  { label: '纪录片库', icon: 'ri-earth-line', color: 'text-accent-400' },
  { label: '动作冒险', icon: 'ri-sword-line', color: 'text-secondary-400' },
  { label: '科幻奇幻', icon: 'ri-rocket-2-line', color: 'text-primary-400' },
  { label: '爱情剧情', icon: 'ri-heart-line', color: 'text-accent-400' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-400 bg-secondary-500/10 rounded-full mb-3">
            内容导航
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            主题索引
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            快速找到你想看的影视类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="group flex items-center gap-3 px-4 py-4 rounded-lg bg-background-100 border border-background-200/60 hover:border-secondary-500/30 transition-all duration-200"
            >
              <span className={`w-9 h-9 rounded-md bg-background-200 flex items-center justify-center flex-shrink-0 group-hover:bg-background-300 transition-colors`}>
                <i className={`${item.icon} text-base ${item.color}`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-900 transition-colors whitespace-nowrap">
                {item.label}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}